import {CONFIG} from "../../config";
import axios from "axios";

async function EditUserQuery(id, email, first_name, last_name, currentPassword, newPassword, description, groups) {
    const data = {
        'email': email,
        'first_name': first_name,
        'last_name': last_name,
        'currentPassword': currentPassword,
        'newPassword': newPassword,
        'description': description,
        'groups': groups
    }

    const location = CONFIG.API_URL + "user/edit/" + id;
    const settings = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('bearer-token')}`,
        }
    };
    try {
        return await axios.post(location, data, settings);
    } catch (e) {
        return e;
    }
}

export default EditUserQuery;